import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\GetGuestSuiteLocationsController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/GetGuestSuiteLocationsController.php
* @route '/api/partner/guest-suite/locations'
*/
const GetGuestSuiteLocationsController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetGuestSuiteLocationsController.url(options),
    method: 'post',
})

GetGuestSuiteLocationsController.definition = {
    methods: ["post"],
    url: '/api/partner/guest-suite/locations',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\GetGuestSuiteLocationsController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/GetGuestSuiteLocationsController.php
* @route '/api/partner/guest-suite/locations'
*/
GetGuestSuiteLocationsController.url = (options?: RouteQueryOptions) => {
    return GetGuestSuiteLocationsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\GetGuestSuiteLocationsController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/GetGuestSuiteLocationsController.php
* @route '/api/partner/guest-suite/locations'
*/
GetGuestSuiteLocationsController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetGuestSuiteLocationsController.url(options),
    method: 'post',
})

export default GetGuestSuiteLocationsController